import React from 'react';

import { Card } from '../Card/Card';
import { CardHeader } from '../Card/CardHeader';
import { CardSection } from '../Card/CardSection';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import meditationSvgUrl from '../../../public/static/svg/meditation.svg?url';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { Button } from '../../element/Button/Button';
import { Gutter } from '../Gutter/Gutter';
import { SmallHeader } from '../../content/SmallHeader/SmallHeader';
import { Grid } from '../Grid/Grid';
import { GridRow } from '../Grid/GridRow';
import { GridColumn } from '../Grid/GridColumn';
import { AxiomLogo } from '../../element/AxiomLogo/AxiomLogo';
import { FluidButtonLayout } from '../FluidButtonLayout/FluidButtonLayout';
import { Layout } from '../Layout/Layout';

export const ErrorLayout = ({
  errorMessage = 'There was a problem completing your request. We apologize for any inconvenience.',
  hideRedirect,
  homeUrl = '/',
  name,
}: React.PropsWithChildren<{
  errorMessage?: string;
  hideRedirect?: boolean;
  homeUrl?: string;
  name?: string;
}>) => {
  const { isLargeScreen } = useBreakpoint();
  return (
    <Grid name={name}>
      <GridRow>
        <GridColumn largeScreenWidth={2} />
        <GridColumn largeScreenWidth={8} smallScreenWidth={12}>
          <Card>
            <CardHeader>
              <SmallHeader name="ERROR_HEADER">
                Opps... Something happened...
              </SmallHeader>
            </CardHeader>
            <CardSection
              name="ERROR_CONTENT"
              background={
                isLargeScreen
                  ? {
                      image: meditationSvgUrl,
                      size: 'cover',
                      position: 'center center',
                    }
                  : {}
              }
            >
              <Grid>
                <GridRow>
                  <GridColumn largeScreenWidth={6} smallScreenWidth={12}>
                    <Gutter vertical="60px">
                      <Layout position="center">
                        <AxiomLogo name="AXIOM_LOGO" />
                      </Layout>
                      <Gutter bottom="16px" />
                      <Paragraph name="ERROR_MESSAGE">
                        {errorMessage}
                        <Gutter bottom="16px" />
                        <i>
                          If you need any assistance, contact{' '}
                          <a href="mailto:answers@axiomlaw.com">
                            Axiom Support
                          </a>
                        </i>
                      </Paragraph>
                    </Gutter>
                  </GridColumn>
                </GridRow>
              </Grid>
            </CardSection>
            {!hideRedirect && (
              <CardSection name="REDIRECT_SECTION" background="light blue">
                <FluidButtonLayout>
                  <Button name="HOME_BUTTON" to={homeUrl}>
                    Home
                  </Button>
                </FluidButtonLayout>
              </CardSection>
            )}
          </Card>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
